import { defineMessages } from 'react-intl';

export default defineMessages({
  costReviewLineItemPurchase: {
    description: 'costReviewLineItemPurchase.addFunds',
    defaultMessage: 'Add Funds',
    id: '991eJI',
  },
  autoFundWarning: {
    description: 'costReviewLineItemPurchase.autoFundWarning',
    defaultMessage: 'Auto-Funding is setup for your Stamps.com account. Your current settings will add needed funds for postage balance.',
    id: 'M6PH2g',
  },
  autoFundMaxPerDayReached: {
    description: 'costReviewLineItemPurchase.autoFundMaxPerDayReached',
    defaultMessage:
      'Your Stamps.com account auto-funded itself {maxPerDay, plural, one {# time} other {# times}} today, which is its current limit. To continue shipping, enter a funding amount to cover the postage difference, or adjust your Auto-Funding settings.',
    id: 'H056FT',
  },
});
